export default __webpack_public_path__ + "static/media/Gauntlets of the Berserker's Fury.15328c28.jpg";